import {
  Sheet,
  SheetHeader,
  SheetTitle,
  SheetDescription,
  SheetContent,
} from '@/components/ui/sheet';
import CalendarEventForm from '@/components/elements/forms/calendarEventForm';
import { DateSelectArg } from '@fullcalendar/core/index.js';

interface AddCalendarEventProps {
  dateSelected?: DateSelectArg;
  show: boolean;
  setShow: (open: boolean) => void;
}

export default function AddCalendarEvent({ ...props }: AddCalendarEventProps) {
  return (
    <Sheet open={props.show} onOpenChange={props.setShow}>
      <SheetContent>
        <SheetHeader>
          <SheetTitle>Add Calendar Event</SheetTitle>
          <SheetDescription>Provide the event details below</SheetDescription>
        </SheetHeader>
        <CalendarEventForm
          startDate={props.dateSelected?.start}
          endDate={props.dateSelected?.end}
          parentShow={props.setShow}
        />
      </SheetContent>
    </Sheet>
  );
}
